import { observer } from 'mobx-react';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

function BaseLayout({ children }: Props) {
  return <div className="flex items-center gap-3">{children}</div>;
}

export default observer(BaseLayout);
